import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Button, Divider, Paper, Typography } from '@mui/material'
import ROUTES from '../../../routesConfig'
import MarketingPageLayout from './MarketingPageLayout'

const MeetupsPage = () => {
  return (
    <MarketingPageLayout>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
        <Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mb: 1 }}>
            Anear for Meetups &amp; Groups
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.65, color: 'rgba(230,233,239,0.9)' }}>
            Meetups are about people—but starting conversations isn't always easy. Anear helps break the ice and connect strangers
            with live, interactive activities. One person can start, and others nearby can join instantly by scanning a QR code.
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            bgcolor: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 2,
            p: 2.5,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1.5 }}>
            Use Anear for
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Icebreakers &amp; introductions
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Live polls and feedback
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Q&amp;A sessions
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Lightweight games
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Group challenges
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mt: 1.25, color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Participants scan a QR code and join instantly—no accounts, no setup friction.
          </Typography>
        </Paper>

        <Box>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
            Flexible &amp; Low-Pressure
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Anear works whether you have 5 people in a café, 30 people in a meetup space, or 100+ people in a hall. Participants
            can join late, leave early, or just watch.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
            Made for Shared Spaces
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Anear isn't about remote play or anonymous users. It's about people in the same room—strangers and friends alike—sharing a moment together and bonding through shared experiences.
          </Typography>
        </Box>

        <Box>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mb: 1.5 }} />
          <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>
            <Button component={RouterLink} to={ROUTES.APPS} variant="contained" color="primary" sx={{ fontWeight: 700 }}>
              Explore apps
            </Button>
            <Button
              component={RouterLink}
              to={ROUTES.HOW_IT_WORKS}
              variant="outlined"
              sx={{ fontWeight: 700, color: '#E6E9EF', borderColor: 'rgba(255,255,255,0.25)' }}
            >
              How it works
            </Button>
          </Box>
        </Box>
      </Box>
    </MarketingPageLayout>
  )
}

export default MeetupsPage


